import {type EventEmitter} from 'node:events';
import {type Hasi} from '@qep/common';
import {type AuthInfo} from './authentication';
import {type WebSocketType} from './base-api';

// eslint-disable-next-line @typescript-eslint/no-restricted-types -- The legacy worker credential helper resolves null on missing credentials.
type NullCredential = null;

export type WorkersType = {
  init: () => Promise<void>;
  credsListener: () => void;
  _getUserCreds: () => Promise<AuthInfo | NullCredential>;
  healthCheck: HealthCheck;
  webSocket: WebSocketType;
  mdsWebSocket: WebSocketType;
  oasWebSocket: WebSocketType;
  sendMessage: (workerName: string, message: string) => void;
  createWorkersIframe: () => HTMLIFrameElement;
};

export type Worker = {
  front: unknown;
  workerFileName: string;
};

export type HealthCheck = {
  healthCheckEmitter: EventEmitter;
  setupWatcherTimer: (statuses: Hasi[]) => void;
  onMessage: (status: Hasi[]) => void;
  allStatesOpen: (statuses: Hasi[]) => boolean;
  isEqual: (statusA: Hasi, statusB: Hasi) => boolean;
  areEqual: (statusesA: Hasi[], statusesB: Hasi[]) => boolean;
  subscribe: (callback: (statuses: Hasi[]) => void) => () => void;
  send: (message: string) => void;
  getHealthCheck: () => void;
};
